import React from 'react';
import Markdown from 'react-markdown';
import type { SlideData } from '../types';

interface SlideContentProps {
  slide: SlideData;
}

interface ContentSectionProps {
  label: string;
  children: React.ReactNode;
}

const ContentSection: React.FC<ContentSectionProps> = ({ label, children }) => (
  <div>
    <span className="text-tiny font-bold text-gray-500">{label}:</span>
    {children}
  </div>
);

export const SlideContent: React.FC<SlideContentProps> = ({ slide }) => {
  if (!slide) return null;

  return (
    <div className="bg-gray-50 rounded-lg p-4 space-y-2">
      <ContentSection label="Slide Title">
        <p className="text-small text-gray-900 mt-1">{slide.title || '-'}</p>
      </ContentSection>

      {slide.text && (
        <ContentSection label="Text Content">
          <div className="prose prose-sm max-w-none text-gray-700 mt-1 text-tiny">
            <Markdown>{slide.text}</Markdown>
          </div>
        </ContentSection>
      )}

      {slide.keywords && slide.keywords.length > 0 && (
        <ContentSection label="Keywords">
          <div className="flex flex-wrap gap-2 mt-2">
            {slide.keywords.map((keyword, index) => (
              <span
                key={index}
                className="inline-flex items-center px-3 py-1 rounded-full text-tiny font-medium bg-blue-100 text-blue-800"
              >
                {keyword}
              </span>
            ))}
          </div>
        </ContentSection>
      )}
    </div>
  );
};
